import React, { useEffect, Fragment } from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import {
  ContentDialog,
  ContentDialogInit,
} from "../components/ContentDialog.jsx";
import { handleDownload } from "../helper.js";
import EMailViewer from "./EMailViewer.jsx";
import PDFViewer from "./PDFViewer.jsx";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import Button from "../../../theme/components/Button.jsx";

DocumentViewer.propTypes = {
  document: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onClose: PropTypes.func,
};

export default function DocumentViewer(props) {
  const { document, onClose = () => {} } = props;
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const { openCD, setOpenCD, tca, setTca, CDActions, setCDActions } =
    ContentDialogInit();

  const handleClose = () => {
    setOpenCD(false);
    onClose();
  };

  useEffect(() => {
    if (document) showDokument(document);
  }, [document]);

  const showDokument = async (document) => {
    if (document.success) {
      let fileData = document.filedata;

      if (!fileData) {
        enqueueSnackbar("Datei konnte nicht geladen werden", {
          variant: "error",
        });
        return;
      }

      let content = <></>;

      switch (document.filetype) {
        case "PDF":
          if (!fileData.startsWith("data:"))
            fileData = "data:" + document.mimetype + ";base64," + fileData;
          content = <PDFViewer document={fileData} />;
          break;
        case "Video":
          if (!fileData.startsWith("data:"))
            fileData = "data:" + document.mimetype + ";base64," + fileData;

          content = (
            <video
              src={fileData}
              controls
              playsInline
              style={{ maxWidth: "100%" }}
            />
          );
          break;
        case "TXT":
          const textDecoder = new TextDecoder("utf-8");
          const decodedFileData = textDecoder.decode(
            new Uint8Array(Array.from(atob(fileData), (c) => c.charCodeAt(0)))
          );
          content = decodedFileData.split("\n").map((line, index) => (
            <React.Fragment key={index}>
              {line}
              <br />
            </React.Fragment>
          ));
          break;
        case "Image":
          if (!fileData.startsWith("data:"))
            fileData = "data:" + document.mimetype + ";base64," + fileData;

          content = (
            <div>
              <img src={fileData} alt={document.filename} />
            </div>
          );
          break;
        case "MSG":
          content = (
            <div>
              Dokument konnte nicht geladen werden. Dokumenttyp wird nicht unterstützt.
            </div>
          );
          break;
        case "EML":
          content = <EMailViewer document={document} />;
          //content = <Fragment>Für diesen Dateityp ist leider keine Vorschau verfügbar. Nutzen Sie bitte den Download Button und versuchen Sie dann die Datei aus Ihrem Downloads Verzeichnis über einen Doppelklick zu öffnen.</Fragment>;
          break;
        case "Download":
          handleDownload(document);
          break;
        default:
          content = (
            <Fragment>
              Für diesen Dateityp ist leider keine Vorschau verfügbar. Nutzen
              Sie bitte den Download Button und versuchen Sie dann die Datei aus
              Ihrem Downloads Verzeichnis über einen Doppelklick zu öffnen.
            </Fragment>
          );
      }
      setOpenCD(true);
      setTca({
        title: document.link ? (
          <Box
            sx={{
              ":hover": {
                backgroundColor: "clickableHover",
                cursor: "pointer",
              },
              backgroundColor: "clickableArea",
              borderStyle: "solid",
              borderWidth: "1px",
              borderColor: "clickableHover",
              p: "5px",
            }}
            onClick={() => navigate("/" + document.link)}
          >
            {document.label}
          </Box>
        ) : (
          document.label
        ),
        content: content,
        maxWidth: "lg",
        actions: (
          <>
            <Button variant="tertiary" onClick={handleClose}>
              Abbruch
            </Button>
            <Button onClick={() => handleDownload(document)}>Download</Button>
          </>
        ),
      });
    } else {
      enqueueSnackbar("Dokument konnte nicht abgerufen werden", {
        variant: "error",
      });
    }
  };

  return (
    <ContentDialog
      openCD={openCD}
      setOpenCD={setOpenCD}
      tca={tca}
      notFullWidth={false}
      centered={true}
      CDActions={CDActions}
      onClose={handleClose}
    />
  );
}
